// Public path
// if set, make sure it ends with /
// e.g. 'assets/'
export const PUBLIC_PATH = 'Areas/Alexion_Global/Assets/';
